import { Card, CardContent } from "@/components/ui/card";
import { useEffect } from "react";

const ContactFormPlaceholder = () => {
  useEffect(() => {
    if (document.querySelector('script[src="https://api.forgesystemsolutions.com/js/form_embed.js"]')) return;
    const script = document.createElement("script");
    script.src = "https://api.forgesystemsolutions.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <Card className="bg-white shadow-2xl border-0 overflow-hidden" id="contact-form">
      <CardContent className="p-0">
        <iframe
          src="https://api.forgesystemsolutions.com/widget/form/BsF1RxpXGiCnVSapZyRi"
          style={{ width: "100%", height: "100%", minHeight: "638px", border: "none", borderRadius: "10px" }}
          id="inline-BsF1RxpXGiCnVSapZyRi"
          data-layout='{"id":"INLINE"}'
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Garrison's Website Form"
          data-layout-iframe-id="inline-BsF1RxpXGiCnVSapZyRi"
          data-form-id="BsF1RxpXGiCnVSapZyRi"
          title="Garrison's Website Form"
          loading="lazy"
        />
      </CardContent>
    </Card>
  );
};

export default ContactFormPlaceholder;
